import AdvancedController from "./advanced-controller";

export default class ImageComparisonSliderController extends AdvancedController {
  static targets = [
    "container", "afterImage", "beforeImage", "slider", "hoverElement"
  ];

  connect() {
    this.updateSliderPosition(50); // Startposition bei 50%

    // Mouse events for desktop
    this.sliderTarget.addEventListener('mousedown', this.startDragging.bind(this));
    window.addEventListener('mouseup', this.stopDragging.bind(this));
    window.addEventListener('mousemove', this.onDrag.bind(this));

    // Touch events for mobile
    this.sliderTarget.addEventListener('touchstart', this.startDragging.bind(this), { passive: true });
    window.addEventListener('touchend', this.stopDragging.bind(this), { passive: true });
    window.addEventListener('touchmove', this.onDrag.bind(this), { passive: true });

    // Debounced resize event
    this.debouncedResize = this.debounce(this.resize.bind(this), 200);
    window.addEventListener('resize', this.debouncedResize);

    this.dragging = false;
    this.setContainerDimensionsBasedOnAspectRatio(); // Set initial dimensions
  }

  disconnect() {
    // Cleanup event listeners when the controller is disconnected
    window.removeEventListener('resize', this.debouncedResize);
  }

  // Debounce function to limit how often resize is triggered
  debounce(func, wait) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }

  resize() {
    // Reset the container size and recalculate dimensions on resize
    this.containerTarget.style.width = 'auto';
    this.containerTarget.style.height = 'auto';
    this.setContainerDimensionsBasedOnAspectRatio();
  }

  setContainerDimensionsBasedOnAspectRatio() {
    const afterImage = this.afterImageTarget;

    // Lade das Bild, um das natürliche Seitenverhältnis zu erhalten
    const image = new Image();
    image.src = afterImage.querySelector('img').src;

    image.onload = () => {
      const aspectRatio = image.naturalWidth / image.naturalHeight;
      const containerWidth = this.containerTarget.clientWidth; // Get current container width

      if (aspectRatio > 1) {
        // Querformat-Bild: Setze die Höhe des Containers
        const calculatedHeight = containerWidth / aspectRatio;
        this.containerTarget.style.height = `${calculatedHeight}px`;
        this.containerTarget.style.width = `${containerWidth}px`; // Breite bleibt 100%
      } else {
        // Hochformat-Bild: Setze die Größe des Containers auf 80%
        const calculatedWidth = containerWidth * 0.8; // 80% der Breite
        const calculatedHeight = (calculatedWidth / aspectRatio); // Höhe basierend auf der Breite
        this.containerTarget.style.width = `${calculatedWidth}px`;
        this.containerTarget.style.height = `${calculatedHeight}px`;
      }
    };

    image.onerror = () => {
      console.error('Bild konnte nicht geladen werden, Standardwerte werden verwendet.');
    };
  }

  startDragging(event) {
    event.preventDefault();
    this.hoverElementTarget.classList.add('--hovering'); // Hover-Effekt aktivieren
    this.dragging = true;
  }

  stopDragging(event) {
    event.preventDefault();
    this.hoverElementTarget.classList.remove('--hovering'); // Hover-Effekt deaktivieren
    this.dragging = false;
  }

  onDrag(event) {
    if (!this.dragging) return;

    let clientX;

    // Check if this is a touch event or mouse event
    if (event.touches) {
      // Mobile touch event
      clientX = event.touches[0].clientX;
    } else {
      // Desktop mouse event
      clientX = event.clientX;
    }

    const rect = this.containerTarget.getBoundingClientRect();
    const position = ((clientX - rect.left) / rect.width) * 100;

    this.updateSliderPosition(position);
    this.hideBeforeAfterLabelsIfCollision();
  }

  updateSliderPosition(percentage) {
    const clampedPercentage = Math.max(0, Math.min(100, percentage)); // Begrenzung zwischen 0% und 100%
    this.beforeImageTarget.style.width = `${clampedPercentage}%`;
    this.sliderTarget.style.left = `${clampedPercentage}%`;
  }

  hideBeforeAfterLabelsIfCollision() {
    const beforeLabel = this.hoverElementTarget.querySelector('.image-comparison-slider__before-label');
    const afterLabel = this.hoverElementTarget.querySelector('.image-comparison-slider__after-label');

    const sliderRect = this.sliderTarget.getBoundingClientRect();
    const beforeRect = beforeLabel.getBoundingClientRect();
    const afterRect = afterLabel.getBoundingClientRect();

    if (sliderRect.right >= afterRect.left) {
      afterLabel.style.visibility = 'hidden'; 
    } else {
     afterLabel.style.visibility = 'visible'; 
    }

    if (sliderRect.left <= beforeRect.right) {
      beforeLabel.style.visibility = 'hidden'; 
    } else {
      beforeLabel.style.visibility = 'visible'; 
    }
  }
}
